import { render, staticRenderFns } from "./routeTemp.vue?vue&type=template&id=0929bb14&scoped=true&"
import script from "./routeTemp.vue?vue&type=script&lang=js&"
export * from "./routeTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0929bb14",
  null
  
)

export default component.exports